import { useNavigate } from 'react-router-dom'
import { FaEye, FaStar } from "react-icons/fa";
import SetAvailability from "./SetAvailabilityBtn"
import { RiRadioButtonLine } from "react-icons/ri";

function SellerBasicDetails({ sellerDetails }) {

    const date = new Date(sellerDetails.createdAt);
    const monthName = date.toLocaleString('default', { month: 'long' });
    const joined = `${monthName}, ${date.getFullYear()}`;
    const navigate = useNavigate();

    return (
        <div className='sellerBasicDetailsDiv'>
            <section className="section">
                <div className="sellerBasicDetailsContent">

                    <div className="profileImageDiv">
                        <img src={`${sellerDetails.profileImage}`} alt="Seller Profile" />
                    </div>

                    <div className="upper">
                        <div className="upperLeft">
                            <h2 className="secondaryHeading">{sellerDetails.displayName}</h2>
                            <p>@{sellerDetails.userId.username}</p>
                            <div className="ratingsDiv">
                                <FaStar className='starIconFilled' />
                                <span>{sellerDetails?.rating?.toFixed(1) + " (" + sellerDetails.noOfReviews + ")"}</span>
                            </div>
                            <p className={`sellerAvailabilityStatus ${sellerDetails.isAvailable ? "available" : "notAvailable"}`}><RiRadioButtonLine /> {sellerDetails.isAvailable? "Available" : "Not Available"}</p>
                            <SetAvailability seller={sellerDetails} source="sellerDashboard" />
                            <button onClick={() => navigate(`/profile/${sellerDetails._id}`)} className="primaryBtn previewProfileBtn"><FaEye /> Preview Profile</button>
                        </div>
                        <div className="verticalLine"></div>
                        <div className="upperRight">
                            <div><p>Seller Type</p><strong>{sellerDetails.sellerType}</strong></div>
                            <div className="horizontalLine"></div>
                            <div><p>From</p><strong>{sellerDetails.country}</strong></div>
                            <div><p>Joined</p><strong>{joined}</strong></div>
                            <div className="horizontalLine"></div>
                            <div><p>Languages</p><strong>{sellerDetails.languages.join(", ")}</strong></div>
                        </div>
                    </div>

                    <div className="horizontalLine"></div>

                    <div className="lower">
                        <h2 className="primaryHeading">About <span>Me</span></h2>
                        <p>{sellerDetails.description}</p>
                    </div>

                </div>
            </section>
        </div>
    )
}

export default SellerBasicDetails